import { render, staticRenderFns } from "./CreateTest.vue?vue&type=template&id=2b941616&scoped=true"
import script from "./CreateTest.vue?vue&type=script&lang=js"
export * from "./CreateTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b941616",
  null
  
)

export default component.exports